Ext.define('SA.data.AttributeClasses', {
    singleton: true,

    Polygon: 'gri\\data\\attribute\\PolygonAttribute',
    USCensusPolygon: 'gri\\data\\attribute\\vendor\\USCensusPolygonAttribute',

    getPolygonClasses() {
        return [this.Polygon, this.USCensusPolygon];
    },

    isPolygonClass(cls) {
        return this.getPolygonClasses().includes(cls);
    }
});